export interface JobReference {
  jobNumber: string;
  projectNumber: string;
}
export class Invoice {
  uid: number | undefined;
  invoiceNumber: number | undefined;
  dateOfInvoice: Date;
  collectionDate: Date;
  jobReference: string | null;
  projectReference: string | null;
  jobs: JobReference[] | null;
  status: string | null;
  poReference: string | null;
  finalInvoiceBoolean: boolean;
  paidBoolean: boolean;
  invoiceFileId: string | null;

  constructor(data: Partial<Invoice>) {
    this.uid = data.uid;
    this.invoiceNumber = data.invoiceNumber;

    // Dates come from firestore as a timestamp, model switches properties to JS Date
    //@ts-expect-error
    this.dateOfInvoice = data.dateOfInvoice.toDate() || null;
    //@ts-expect-error
    this.collectionDate = data?.collectionDate?.toDate() || null;

    this.jobReference = data.jobReference || null;
    this.projectReference = data.projectReference || null;
    this.jobs = data.jobs || null;
    this.status = data.status || null;
    this.poReference = data.poReference || null;
    this.finalInvoiceBoolean = data.finalInvoiceBoolean || false;
    this.paidBoolean = data.paidBoolean || false;
    this.invoiceFileId = data.invoiceFileId || null;
  }

  get fileUrl() {
    return `https://drive.google.com/file/d/${this.invoiceFileId}/view`;
  }
}
